import AppConfigStore from '../../stores/AppConfigStore';
import EpicGamesNavImpl from 'epic-games-nav/app/scripts/EpicGamesNavImpl';
import LocalizationStore from '../../stores/LocalizationStore';
import {LoginActions} from '../../actions';
import LoginStore from '../../stores/LoginStore';
import PropTypes from 'prop-types';
import SubscriptionStore from '../../stores/SubscriptionStore';
import {connectToStores} from 'epic-alt-utils/index';
import {processParams} from 'epic-common/src/url';

@connectToStores
class EpicGamesNavWrapper extends EpicGamesNavImpl {
    static propTypes = {
        history: PropTypes.object,
        location: PropTypes.object,
        subscriptionStore: PropTypes.object,
        localizationStore: PropTypes.object,
        headerStore: PropTypes.object,
        appConfigStore: PropTypes.object,
        loginStore: PropTypes.object
    };
    static getStores() {
        return [SubscriptionStore, AppConfigStore, LoginStore];
    }

    static getPropsFromStores() {
        return {
            subscriptionStore: SubscriptionStore.getState(),
            appConfigStore: AppConfigStore.getState(),
            localizationStore: LocalizationStore.getState(),
            loginStore: LoginStore.getState()
        };
    }

    setCTA() {
        const {subscriptionStore, appConfigStore, localizationStore, loginStore} = this.props;
        const isGameLaunched = appConfigStore.checkGameLaunched();
        const {launched, info} = isGameLaunched;
        const {isLoggedIn} = loginStore;

        if (subscriptionStore.isSubscribed && !launched) return {};
        const config = this.props.headerStore.config ? this.props.headerStore.config.asMutable({deep: true}) : {};
        const {callToAction} = config;

        //if country not launched and user clicks sign up in header we send the user to sign in first.
        if (!isLoggedIn && !launched && callToAction) {
            callToAction.onClick = (e) => {
                e.preventDefault();
                LoginActions.requestLogin('/beta-sign-up');
            }
        }
        
        if (callToAction && callToAction.useCustomCallback) {
            callToAction.onClick = (e) => {
                e.preventDefault();
            };
        }
        //if game is launched in country
        if (launched) {
            callToAction.title = localizationStore.message('epic.common.download');
            callToAction.href = `${info.iosLink}?isFromCTA=true`;
        }
        
        return callToAction;
    }
    
    setAccountLinks(accountLinks) {
        let newAccountLinks = accountLinks;
        const params = {
            state: this.props.location.pathname || '/'
        };
        const linkQueryString = `?${processParams(params)}`;
        if (newAccountLinks.signInLinks && newAccountLinks.signInLinks.length) {
            newAccountLinks = newAccountLinks.setIn(['signInLinks', 0, 'href'], `/spyjinx/login${linkQueryString}`);
        }
        if (newAccountLinks.signOutLink) {
            newAccountLinks = newAccountLinks.setIn(['signOutLink', 'href'], `/spyjinx/logout${linkQueryString}`);
        }
        return newAccountLinks;
    }
}

export default EpicGamesNavWrapper;
